<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜索条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="特价">
                            <el-input v-model="q.sid" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="产品编号">
                            <el-input v-model="q.proCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="国科sap订单号">
                            <el-input v-model="q.gkSapCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="变价需求号">
                            <el-input v-model="q.avaiId" :clearable="true"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="queryPage">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column type="index" width="50" label="序号" fixed></el-table-column>
                    <el-table-column prop="sid" label="特价版本ID" :show-overflow-tooltip="true" width="140"></el-table-column>
                    <el-table-column prop="proCode" label="产品编号" :show-overflow-tooltip="true" width="140"></el-table-column>
                    <el-table-column prop="dingjia" label="产品定价" width="110"></el-table-column>
                    <el-table-column prop="proDiscount" label="产品折扣" width="110"></el-table-column>
                    <el-table-column prop="proDiscPrice" label="折扣价格" width="110"></el-table-column>
                    <el-table-column prop="totalNumber" label="特价申请数量" width="110"></el-table-column>
                    <el-table-column prop="avaiNumber" label="使用前剩余数量" width="130"></el-table-column>
                    <el-table-column prop="avaiNumberNew" label="剩余数量" width="120"></el-table-column>
                    <el-table-column prop="avaiNumberDiff" label="使用数量" width="130"></el-table-column>
                    <el-table-column prop="gkSapCode" label="国科sap订单号" :show-overflow-tooltip="true" width="160"></el-table-column>
                    <el-table-column prop="avaiId" label="变价需求号" :show-overflow-tooltip="true" width="160"></el-table-column>
                    <el-table-column prop="cuname" label="创建人名称" width="110"></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" :formatter="formatDatecc" width="130"></el-table-column>
<!--                  <el-table-column
                      fixed="right"
                      label="操作"
                      width="100"
                  >
                    <template slot-scope="scope">
                      <el-button
                          size="small" class="h-tableLink h-btn"
                          @click="chehui(scope.row.id)">作废
                      </el-button>
                    </template>
                  </el-table-column>-->



                </el-table>

                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="downExcel">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="queryPage" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";
    import updownfile from "../../../utils/updownfile";

    export default {
        data() {
            return {
                q: {
                    sid: null,
                    proCode: null,
                    bizhong: null,
                    tejiafangshi: null,
                    funnelCode: null,
                    gkSapCode: null,
                    avaiId: null,
                    delflag: 1,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
            }
        },
        created() {
            this.queryPage();
        },
        methods: {
            // 查询
            queryPage() {
                ss.GKOrderPage.gkTejiaSelect(this.q).then(res => {
                    this.q.total = res.total;
                    this.tableData = res.records;
                });
            },
            // 重置（保留分页）
            resetData() {
                const pageSize = this.q.pageSize;
                const pageNo = this.q.pageNo;
                const total = this.q.total;
                this.q = {
                    sid: null,
                    proCode: null,
                    bizhong: null,
                    tejiafangshi: null,
                    funnelCode: null,
                    gkSapCode: null,
                    avaiId: null,
                    delflag: 1,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total: total,
                };
                this.queryPage();
            },
            // 日期格式化
            formatDatecc(row, column) {
                const data = row[column.property];
                if (data == null || data == '') return null;
                return this.$util.riQi3(new Date(data));
            },
            downExcel() {
                updownfile.down("/api/swyl/v1/demo/specialOfferAvaiNumberLog/downloadExcel", this.q, "get");
            },
            // 作废
            chehui(id){

              this.$msg.confirm("是否确认作废?", () => {
                ss.GKOrderPage.gkTejiaWithdraw(id).then(res => {
                  this.$message({
                    message: '作废成功',
                    type: 'success'
                  });
                  this.queryPage();
                });
              });
            },
        },
    }
</script>

<style scoped></style>
